import { Instance, types } from "mobx-state-tree";
import { config } from "@fidget/common/config/config";

const TypingEvent = types.model("TypingUser", {
  userId: types.string,
  preview: types.maybe(types.string)
});

export const TypingStore = types
  .model("TypingStore", {
    events: types.array(TypingEvent),
    timers: types.map(types.number)
  })
  .views((self) => ({
    getTypingEvents(): ReadonlyArray<ITypingEvent> {
      return self.events;
    }
  }))
  .actions((self) => {
    const actions = {
      updateTypingUser(userId: string, preview?: string): void {
        const shouldTimeout = !preview || preview === "";
        const timer = self.timers.get(userId);

        if (timer) {
          clearTimeout(timer);
          self.timers.delete(userId);
        }

        const event = self.events.find((ev) => ev.userId === userId);
        if (event) {
          event.preview = preview;
        } else {
          self.events.push(TypingEvent.create({ userId, preview }));
        }

        if (shouldTimeout) {
          const timeout =
            preview !== undefined
              ? config.services.times.chatTypingTimeoutMillis * 2
              : config.services.times.chatTypingTimeoutMillis;
          const newTimer = window.setTimeout(() => {
            actions.removeTypingUser(userId);
          }, timeout);
          self.timers.set(userId, newTimer);
        }
      },

      removeTypingUser(userId: string): void {
        const timer = self.timers.get(userId);

        if (timer) {
          clearTimeout(timer);
          self.timers.delete(userId);
        }

        self.events.replace(self.events.filter((ev) => ev.userId !== userId));
      },

      clearTypingUsers(): void {
        self.timers.clear();
        self.events.replace([]);
      }
    };

    return actions;
  });

export interface ITypingStore extends Instance<typeof TypingStore> { }
export interface ITypingEvent extends Instance<typeof TypingEvent> { }
